<script lang="ts">
import { onMount } from "svelte";
import { navigate } from "svelte-navigator";

import type { Answer } from "../Model/Answer";
import type { Question } from "../Model/Question";
import { questionsService, answersService } from "../services";

type QuestionAnswers = {
  question: Question,
  answers: Answer[]
}

let questionAnswers: QuestionAnswers[] = [];
let viewOptions: Boolean = true;

onMount(() => {
  const passWord = prompt('contraseña');
  
  if (passWord != 'quimera159') {
    return
  }

  loadQuestions();

})

async function loadQuestions(){
    const questions = await questionsService.findQuestions();   
    const answers = await answersService.findAnswers();

    questionAnswers = questions.map(question => ({
      question,
      answers: answers.filter(({ questionId }) => questionId == question.id)
    }))

}


</script>

<style lang="scss">

.body-html {
    height: 100%;
      display: flex;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 40px;
      max-width: 360px;
      margin: auto;
  }


  img{
    width: 60%;
    height: auto;
  }

  .img-icon{
    max-width: 70px;
    margin-bottom: 30px;
  }

  .font-tittle{
    color: white;
    font-size: 45px;
  }

  .second-tittle{
        font-family: 'Lato', sans-serif !important;
        color: #FEB531;
        font-size: 18px;
        font-style: italic;
    }

  .third-tittle{
        font-family: 'Lato', sans-serif !important;
        color: #FFF;
        font-size: 18px;
        font-style: italic;
    }


  .button-opcion{
    width: 100%;
    height: 150px;
    margin-bottom: 20px;
    color: white;
    font-size: 30px;
  }

  hr{
        color: #FFFFFF;
        max-width: 242px;
        margin: auto;
        opacity: 1;
        margin-bottom: 50px;
        margin-top: 50px;
        height: 1px;
    }

</style>

  <div class="body-html">
    <div class="container">
      <div class="row">
  
        {#if questionAnswers && viewOptions}  
          <div class="mb-3 col-12 text-center">
            <h1 class="mb-3 font-tittle">Resultados</h1>
          </div>
          {#each questionAnswers as {question, answers} }
            <div class="col-12 text-center">
              <button class="button-opcion" style="background-image: url('img/{question.imagen}.jpg')">
                {question.name} / {answers.length}
              </button>
            </div>
          {/each}
        {/if}
  
   
  

      </div>
    
     
  
  
    </div>
  </div>
